import React from 'react';

// import { Container } from './styles';

const NotFound: React.FC = () => {
  return <span>Page Note Found</span>;
};

export default NotFound;
